import AuthView from '@/pages/auth';
import CompanyView from '@/pages/company';

import store from '@/store';

/* const defaultRouteName = window.appConfig.SCB_BILLING_APP_MODE === 'admin' ?
  process.env.DEFAULT_ROUTE_NAME : process.env.DEFAULT_BILLER_ROUTE_NAME; */

const requireAdmin = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    return next({ name: 'Login' });
  } else if (store.getters.needResetPwd && ['ResetPassword', 'Logout'].indexOf(to.name) === -1) {
    return next({ name: 'ResetPassword' });
  } else if (store.getters.isBiller) {
    return next({ name: 'Logout' });
  }
  return next();
};

const routes = [
  {
    path: '/',
    name: 'AdminUserLoadInfo',
    component: CompanyView.adminLoadInfo,
    beforeEnter: requireAdmin,
    meta: {
      title: 'กำลังโหลด...',
    },
  },
  // Company
  {
    path: '/company',
    name: 'CompanyList',
    component: CompanyView.companyList,
    beforeEnter: requireAdmin,
    meta: {
      title: 'รายชื่อบริษัท',
    },
  },
  {
    path: '/company/create',
    name: 'CompanyCreate',
    component: CompanyView.companyForm,
    beforeEnter: requireAdmin,
    meta: {
      title: 'เพิ่มรายละเอียดบริษัทใหม่',
    },
  },
  {
    path: '/company/:companyId',
    props: true,
    name: 'CompanyDetail',
    component: CompanyView.companyDetail,
    beforeEnter: requireAdmin,
    meta: {
      title: 'รายละเอียดบริษัท',
    },
  },
  {
    path: '/company/:companyId/edit',
    props: true,
    name: 'CompanyEdit',
    component: CompanyView.companyForm,
    beforeEnter: requireAdmin,
    meta: {
      title: 'แก้ไขรายละเอียดบริษัท',
    },
  },
  // Company Admin
  {
    path: '/company/:companyId/admin',
    props: true,
    name: 'CompanyAdminList',
    component: CompanyView.companyAdminList,
    beforeEnter: requireAdmin,
    meta: {
      title: 'รายชื่อบัญชีผู้ดูแลบริษัท',
    },
  },
  {
    path: '/company/:companyId/admin/create',
    props: true,
    name: 'CompanyAdminCreate',
    component: CompanyView.companyAdminForm,
    beforeEnter: requireAdmin,
    meta: {
      title: 'เพิ่มบัญชีผู้ดูแลบริษัท',
    },
  },
  {
    path: '/company/:companyId/admin/:userId',
    props: true,
    name: 'CompanyAdminEdit',
    component: CompanyView.companyAdminForm,
    beforeEnter: requireAdmin,
    meta: {
      title: 'แก้ไขบัญชีผู้ดูแลบริษัท',
    },
  },
  // Company Profiles
  {
    path: '/company/:companyId/profile/:profileId/edit',
    props: true,
    name: 'CompanyProfileEdit',
    component: CompanyView.companyProfileForm,
    beforeEnter: requireAdmin,
    meta: {
      title: 'แก้ไขข้อมูลบริษัทสำหรับรับชำระ',
    },
  },
  {
    path: '/company/:companyId/profile/:profileId/view',
    props: true,
    name: 'CompanyProfileDetail',
    component: CompanyView.companyProfileDetail,
    beforeEnter: requireAdmin,
    meta: {
      title: 'ข้อมูลบริษัทสำหรับรับชำระ',
    },
  },
  {
    path: '/company/:companyId/profile/create',
    props: true,
    name: 'CompanyProfileCreate',
    component: CompanyView.companyProfileForm,
    beforeEnter: requireAdmin,
    meta: {
      title: 'เพิ่มข้อมูลบริษัทสำหรับรับชำระ',
    },
  },
  {
    path: '/company/:companyId/profile',
    props: true,
    name: 'CompanyProfileList',
    component: CompanyView.companyProfileList,
    beforeEnter: requireAdmin,
    meta: {
      title: 'รายชื่อข้อมูลบริษัทสำหรับรับชำระ',
    },
  },
  // Admin Users
  {
    path: '/admins',
    name: 'AdminAccountList',
    component: AuthView.adminAccountList,
    beforeEnter: requireAdmin,
    meta: {
      title: 'รายชื่อบัญชีผู้ใช้งาน',
    },
  },
  {
    path: '/admins/create',
    name: 'AdminAccountCreate',
    component: AuthView.adminAccountForm,
    beforeEnter: requireAdmin,
    meta: {
      title: 'เพิ่มบัญชีผู้ใช้งาน',
    },
  },
  {
    path: '/admins/:adminId',
    props: true,
    name: 'AdminAccountEdit',
    component: AuthView.adminAccountForm,
    beforeEnter: requireAdmin,
    meta: {
      title: 'แก้ไขบัญชีผู้ใช้งาน',
    },
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes/admin.js